import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Archivo is bundled with the app (never fetched from Google at run time): the design's
// own variable font files, see fonts.css.
import './fonts.css';
// Archivo is the only typeface (Andrew, 2026-10-01): where the design used a mono face
// to line figures up, Archivo's tabular numbers do it.
import '@aithora/shared/tokens.css';
import './motion.css';
import './styles.css';
import './ui/ui.css';
import './ui/shared.css';
import './pages/overview/overview.css';
import './pages/overview/operator.css';
import './pages/overview/facilityAdmin.css';
import './pages/overview/careStaff.css';
import { App } from './App';
import { captureSsoReturn } from './auth/signinExtras';
import { redirectPhoneIfNeeded } from './phoneRedirect';
// Light / Dark / Auto (V6): the design's dark rules, last so they win; the viewer's choice applied before the first paint.
import './theme-dark.css';
import './theme-dark-classes.css';
import { applyTheme, readThemePref } from './ui/theme';

applyTheme(readThemePref());

// A phone gets the phone app at /m/ (phoneRedirect.ts), before the shell renders.
if (!redirectPhoneIfNeeded()) {
  // Back from single sign-on: lift the session out of the URL before anything routes.
  captureSsoReturn();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
